import { CustomToastrAction, toastr } from "@/imports-files/common/common";
import { CandidateListAction } from "@/services/components/candidate-listing-action";
import { deselectAllCandidates, getSelectedCandidateId } from "./candidate-bulk-action";

export async function getCandidateActiveJobList(params)
{
    var result = await new CandidateListAction().ActiveJobList(params);
    return result.data.jobs;

}

export async function addCandidateToJob(setSelectJobId, selectedCandidateId, setCandidateAddToJobModal, setCandidateBulkActionModal, from)
{
    var job_id                   =      setSelectJobId;
    var candidate_ids            =      getSelectedCandidateId();
    var body                     =      '';
    const customToastrAction     =      new CustomToastrAction(); 
    
    if(candidate_ids.length == 0)
    {
        candidate_ids = [selectedCandidateId];
    }

    body              =   {'candidate_ids': candidate_ids, 'job_id': job_id};
    setCandidateAddToJobModal(false);
    
    if(!(from && from == 'candidate_view'))
    {   setCandidateBulkActionModal(false);
        deselectAllCandidates();
    }
    
    var result           =   await new CandidateListAction().addToJobs(body);


    if(result?.data?.success)
    {
        customToastrAction.setNormalToastr(result.data.success, 'success'); 
        // toastr.success(result.data.success);
    }
    else if (result?.response?.data?.error)
    {
        customToastrAction.setNormalToastr(result.response.data.error, 'error');
    }
    else
    {
        customToastrAction.setNormalToastr(result.response.statusText, 'error');
        // toastr.error(result.response.statusText);
    }
}

export function handleSelectJobValueOnChange(data, setSelectJobId, formik)
{
    formik.setFieldValue("select_job", data.value);
    setSelectJobId(data.value);
}
